
import React, { memo, useMemo } from "react";

import { Link } from "react-router-dom";

import Card9 from "components/Card9/Card9";

import ArticleSkeleton from
  "../../components/Sections/ArticleSkeleton";

const WidgetCategoriesSecond = ({
  className = "",
  categories,
  live,
  posts = [],
  loading,
}) => {

  // =====================================================
  // WYBIERAMY 3 NAJNOWSZE ARTYKUŁY
  // =====================================================

  const data = useMemo(() => {

    if (!Array.isArray(posts) || posts.length === 0) {
      return [];
    }

    return posts
      .filter((post) => post.section_id === 5)
      .sort((a, b) => {
        return (
          new Date(b.date).getTime() -
          new Date(a.date).getTime()
        );
      })
      .slice(0, 3);

  }, [posts]);

  // =====================================================
  // LOADING
  // =====================================================

  const isLoading =
    loading !== undefined
      ? loading
      : posts.length === 0;

  // =====================================================
  // RENDER
  // =====================================================

  return (
    <div
      style={{
        marginTop: "20px",
      }}
      className={`nc-WidgetCategories overflow-hidden container ${className}`}
    >

      <div
        className="
          grid
          nysa-scale
          grid-cols-1
          sm:grid-cols-2
          lg:grid-cols-3
          xl:grid-cols-3
          gap-6
          md:gap-8
        "
      >

        {/* LOADING */}

        {isLoading ? (

          Array.from({ length: 3 }).map((_, index) => (
            <ArticleSkeleton
              key={`skeleton-${index}`}
            />
          ))

        ) : (

          /* ARTYKUŁY */

          data.map((item) => (

            <article
              key={item.id}
              style={{
                display: "grid",
                alignContent: "baseline",
              }}
            >

              {/* KARTA */}

              <Card9 post={item} />

              {/* INFORMACJE */}

              <div
                style={{
                  display: "flex",
                  flexFlow: "column",
                  gap: "10px",
                  paddingTop: "5px",
                }}
              >

                {/* TYTUŁ */}

                <Link
                  className="dark:hover:text-white"
                  to={`
                    /${item?.title?.toLowerCase()}/
                    ${
                      item?.name === "Świat"
                        ? "swiat"
                        : item?.name?.toLowerCase()
                    }/
                    ${item?.category_id}/
                    ${item?.subcategory_id}/
                    artykuł/
                    ${item?.id}
                  `.replace(/\s+/g, "")}
                >

                  <h3 className="mobile-font">
                    {item?.article_title}
                  </h3>

                </Link>

                {/* KATEGORIA */}

                <span
                  className="category-titles"
                  style={{
                    color: "red",
                    fontWeight: 700,
                  }}
                >
                  {item?.name} - {item?.title}
                </span>

                {/* OPIS */}

                <p
                  className="article-descy"
                  style={{
                    textAlign: "justify",
                  }}
                >
                  {item?.description?.slice(0, 80)}...
                </p>

                {/* DATA */}

                <span
                  className="category-titles"
                  style={{
                    color: "grey",
                    fontWeight: 700,
                  }}
                >
                  {item?.date != null &&
                    new Date(item.date).toLocaleString()}
                </span>

              </div>

              {/* SEPARATOR */}

              <hr
                className="mobile-line"
                style={{
                  padding: "1px",
                  marginTop: "20px",
                  backgroundColor: "#ac8502",
                }}
              />

            </article>

          ))

        )}

      </div>

    </div>
  );
};

export default memo(WidgetCategoriesSecond);
